import { Component, Host, h, Prop } from '@stencil/core';
import { checkLanguageCookie } from '../../utils/utils';
 
@Component({
  tag: 'footer-main',
  styleUrl: 'footer-main.css',
  shadow: true,
})
export class FooterMain {
  /**
   * The Menu Items
   */
  @Prop() menuItems: string;

  /**
   * The Footer Logo
   */
  @Prop() footerLogo: string;

  componentWillLoad() {
    this.preloadFooterLogo();
  }

  preloadFooterLogo() {
    if (this.footerLogo) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = this.footerLogo;
      document.head.appendChild(link);
      //console.log(`Preloading footer logo: ${this.footerLogo}`);
    }
  }

  render() {
    const menuItems = JSON.parse(this.menuItems);
    const footerLogo = this.footerLogo;
    //console.log('footerLogo', footerLogo);

    // Get the language code from the cookie
    const langCode = checkLanguageCookie('wp-wpml_current_language');
    // Construct the href dynamically
    const href = langCode ? `/${langCode}/resource-center` : '/resource-center';

    return (
      <Host>
        <div class={`bg-dark-blue`}>
          <div class={`container  pt-40px`}>
            <div class={`footer-body`}>
              {menuItems.length > 0 &&
                menuItems.map(({ title, submenu }) => (
                  <div class={`flex flex-col  footer-column`}>
                    <h3 class={`text-light-blue cursor-notallowed`}>{title}</h3>
                    {submenu.length > 0 &&
                      submenu.map(({ title, url, classes }) => (
                        <a class={`footer-link  ${classes}`} href={url}>
                          {title}
                        </a>
                      ))}
                  </div>
                ))}
            </div>
            <div class={`footer-bottom border-t-2 border-t-light-blue py-24px  text-white flex justify-between`}>
              <a href={href} title="3e logo">
                <image-block imageAlt="3e Logo" imageUrl={footerLogo} imageWidth={75} imageHeight={25} imageClass="footer-logo"></image-block>
              </a>
              <div class={`fs-0`}>
                &copy;{new Date().getFullYear()} 3E. All rights reserved. |{' '}
                <a href="/sitemap.xml" class={`footer-link`}>
                  Sitemap
                </a>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
